const suffixes: [string, number][] = [
    ['TB', 1_000_000_000_000],
    ['GB', 1_000_000_000],
    ['MB', 1_000_000],
    ['KB', 1000]
];

export function formatBytes(bytes: number): string {
    for (let entry of suffixes) {
        const [suffix, size] = entry;
        if (bytes >= size) {
            return `${(bytes / size).toFixed(2)} ${suffix}`;
        }
    }

    return `${bytes} B`;
}
